// extracted by mini-css-extract-plugin
module.exports = {"loader":"PasswordResetForm_loader__2-NSq","root":"PasswordResetForm_root__2LnEi","password":"PasswordResetForm_password__uty2J"};